import * as Yup from 'yup';

/**
 * Здесь мы задаем текст ошибок по умолчанию с поддержкой i18n.
 * Выводить нужно через i18n.t(error.validation.key, {...error.validation.options}) или <Trans .../>
 */
Yup.setLocale({
  mixed: {
    required: { key: 'error.required', options: { ns: 'common' } },
    notType: ({ type }) => ({ key: `error.${type as string}.default` }),
  },
});

export const yup = Yup;
